(function () {
  var BOTTOM_GAP = 64;
  var TOP_GAP = 24;
  var mq = window.matchMedia('(min-width: 990px)');
  var container = null;
  var infoMain = null;
  var ticking = false;
  var resizeObserver = null;

  var STYLE_KEYS = ['position', 'top', 'bottom', 'left', 'width'];

  // Only touch the inline styles that actually change, so re-running every frame
  // (scroll, or content animating open) never flips the column out of place mid-frame.
  function apply(next) {
    if (!infoMain) return;
    STYLE_KEYS.forEach(function (key) {
      var value = next[key] || '';
      if (infoMain.style[key] !== value) infoMain.style[key] = value;
    });
  }

  function reset() {
    apply({});
  }

  function update() {
    ticking = false;
    if (!container || !infoMain) return;

    if (!mq.matches) {
      reset();
      return;
    }

    var containerRect = container.getBoundingClientRect();
    var viewportHeight = window.innerHeight;
    // Height doesn't depend on how the column is positioned, so measure it as-is.
    var mainHeight = infoMain.offsetHeight;
    var restTop = viewportHeight - BOTTOM_GAP - mainHeight;

    // Short info columns (e.g. ready-to-ship bags) fit on screen: keep them pinned at the top, just under the header.
    var header = document.querySelector('.shopify-section-header');
    var topOffset = (header ? Math.max(header.getBoundingClientRect().bottom, 0) : 0) + TOP_GAP;
    if (mainHeight <= viewportHeight - BOTTOM_GAP - topOffset) {
      apply({ position: 'sticky', top: topOffset + 'px' });
      return;
    }

    if (containerRect.top >= restTop) {
      apply({ position: 'static' });
      return;
    }

    if (containerRect.bottom <= viewportHeight - BOTTOM_GAP) {
      apply({ position: 'absolute', top: 'auto', bottom: '0', left: '0', width: '100%' });
      return;
    }

    apply({
      position: 'fixed',
      top: 'auto',
      bottom: BOTTOM_GAP + 'px',
      left: containerRect.left + 'px',
      width: containerRect.width + 'px'
    });
  }

  function onScrollOrResize() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  }

  function init() {
    container = document.querySelector('.product__outer--static-column-aside .product__info-container');
    infoMain = container ? container.querySelector('.product__info-main') : null;
    if (!container || !infoMain) return;
    container.style.position = 'relative';
    update();

    // Re-pin while the column's content changes height (e.g. the fabric picker animating open),
    // so it grows downward instead of being pushed up from the bottom.
    if (window.ResizeObserver && infoMain.firstElementChild) {
      if (resizeObserver) resizeObserver.disconnect();
      resizeObserver = new ResizeObserver(onScrollOrResize);
      resizeObserver.observe(infoMain.firstElementChild);
    }
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  window.addEventListener('scroll', onScrollOrResize, { passive: true });
  window.addEventListener('resize', onScrollOrResize);
  mq.addEventListener('change', onScrollOrResize);
})();
